<template>
  <b-modal
    v-model="isShown"
    :title="$t('views.cart.upload_cart_from_file')"
    modal-class="spdo-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @hidden="hideModal"
  >
    <div class="my-4">
      <p class="text-danger">
        {{ $t('views.cart.upload_warning') }}
      </p>
      <div class="my-3">
        <!-- eslint-disable max-len -->
        <button
          :disabled="loading"
          class="btn spdo-button spdo-button_line spdo-button_lowercase upload-cart__btn"
          @click="downloadTemplateTxt()"
        >
          <v-icon>mdi-download</v-icon>
          {{ $t('views.cart.download_template_txt') }}
        </button>
        <!-- eslint-enable max-len -->
        <a
          v-if="txtTemplate"
          v-show="false"
          ref="txtTemplate"
          :href="txtTemplate"
          download="txt-template.txt"
        />
        <!-- eslint-disable max-len -->
        <button
          :disabled="loading"
          class="btn spdo-button spdo-button_line spdo-button_lowercase upload-cart__btn"
          @click="downloadTemplateXlsx()"
        >
          <v-icon>mdi-download</v-icon>
          {{ $t('views.cart.download_template_xlsx') }}
        </button>
        <!-- eslint-enable max-len -->
        <a
          v-if="xlsxTemplate"
          v-show="false"
          ref="xlsxTemplate"
          :href="xlsxTemplate"
          download="xlsx-template.xlsx"
        />
      </div>

      <div>
        <!-- eslint-disable max-len -->
        <button
          :disabled="loading"
          class="btn spdo-button spdo-button_line spdo-button_lowercase upload-cart__btn"
          @click="selectFile()"
        >
          {{ $t('common.select_file') }}
        </button>
        <!-- eslint-enable max-len -->
        <span
          v-if="file"
          class="upload-cart__filename"
        >
          {{ file.name }}
        </span>
        <input
          v-show="false"
          ref="file"
          type="file"
          accept=".txt, .xlsx"
          @change="setFile()"
        >
      </div>
    </div>

    <div class="v-application d-flex">
      <v-btn
        :disabled="loading"
        outlined
        large
        class="mr-4 flex-grow-1"
        @click="hideModal"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        :disabled="loading || !file"
        color="primary"
        outlined
        large
        class="flex-grow-1"
        @click="uploadFile()"
      >
        <v-icon>mdi-upload</v-icon>
        {{ $t('common.upload') }}
      </v-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'UploadCart',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isShown: false,
      txtTemplate: null,
      xlsxTemplate: null,
      file: null,
      loading: false,
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    async downloadTemplateTxt() {
      if (!this.txtTemplate) {
        this.loading = true;
        try {
          const { data } = await this.$http.get('/orders/txt-template', {
            headers: {
              'Content-Type': 'text/plain',
            },
            responseType: 'blob',
          });
          this.txtTemplate = URL.createObjectURL(data);
          await this.$nextTick();
        } finally {
          this.loading = false;
        }
      }
      this.$refs.txtTemplate.click();
    },

    async downloadTemplateXlsx() {
      if (!this.xlsxTemplate) {
        this.loading = true;
        try {
          const { data } = await this.$http.get('/orders/xlsx-template', {
            headers: {
              'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob',
          });
          this.xlsxTemplate = URL.createObjectURL(data);
          await this.$nextTick();
        } finally {
          this.loading = false;
        }
      }
      this.$refs.xlsxTemplate.click();
    },

    hideModal() {
      this.$emit('input', false);
    },

    selectFile() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },

    setFile() {
      [this.file] = this.$refs.file.files;
    },

    async uploadFile() {
      this.loading = true;
      try {
        const { type } = this.file;
        const apiUrl = type === 'text/plain' ? 'orders/txt' : 'orders/xlsx';
        const formData = new FormData();
        formData.append('file', this.file);
        const { data } = await this.$http.post(apiUrl, formData);
        this.$store.commit('replaceCart', data[0].parts);
        this.hideModal();
      } finally {
        this.loading = false;
        this.$refs.file.value = null;
        this.file = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-cart__btn {
  padding: 10px 30px;
  margin-right: 20px;
}

.upload-cart__filename {
  color: var(--topaz)
}
</style>
